import type { Translation } from "../types";

export const translationsLV: Translation= {
    chooseColor: "Izvēlies katram produktam atbilstošu krāsu",
    green: "ATĻAUTS",
    red: "NAV ATĻAUTS",
    yellow: "DAĻĒJI ATĻAUTS",
    greenExplanation: "Šo produktu vari lietot bez ierobežojumiem",
    redExplanation: "Šo prodktu lietot nav atļauts",
    yellowExplanation: "Šo produktu vari lietot sekojot ārsta ieteikumiem, ierobežotā daudzumā",
    navigationBack: "ATPAKAĻ",
    navigationStart: "SĀKT",
    chooseColorOfProduct: "Izvēlies atbilstošo krāsu: ",
    thankYou: "Paldies par piedalīšanos!",
    showResults: "RĀDĪT REZULTĀTUS",
    yourResults: "Jūsu rezultāti:",
    product: "Produkts",
    yourAnswer: "Jūsu atbilde",
    correctAnswer: "Pareizā atbilde",
    goodJob: "Malacis!",
    goodButKeepLearning: "Tavs rezultāts ir labs, bet patrenējies un aprunājies ar FKU komandu!",
    contactYourDoctor: "Ludzu konsultējies ar FKU komandu!",
    correctAnswers: "Pareizās atbildes",
    from: "no",
    yes: "JĀ", 
    continue: "TURPINĀT",
    areYouSure: "Vai tiešām vēlies beigt spēli?",
    playAgain: "Spēlēt vēlreiz",
    stillLeft: "Atlikuši", 
    questions: "jautājumi",
    saveResults: "Saglabāt rezultātus",
    save: "SAGLABĀT",
    enterPatientsName: "Ievadi pacienta vārdu un uzvārdu, lai saglabātu rezultātus PDF formātā (angļu valodā)",
    inputPlaceholder: "Lūdzu ievadi pacienta vārdu un uzvārdu",
    validationText: "Jābūt ievadītam vismaz 5 simbolu garam vārdam",

}

export const translationsRU: Translation= {
    chooseColor: "Выберите подходящий цвет для каждого продукта",
    green: "РАЗРЕШЕНО",
    red: "ЗАПРЕЩЕННЫЙ",
    yellow: "ЧАСТИЧНО РАЗРЕШЕНО",
    greenExplanation: "Вы можете использовать этот продукт без ограничений",
    redExplanation: "Этот продукт не разрешен к использованию",
    yellowExplanation: "Вы можете использовать этот продукт, следуя рекомендациям врача, в ограниченных количествах.",
    navigationStart: "НАЧАТЬ",
    navigationBack: "НАЗАД",
    chooseColorOfProduct: "Выберите подходящий цвет: ",
    thankYou: "Спасибо за участие!",
    showResults: "ПОКАЗАТЬ РЕЗУЛЬТАТЫ",
    yourResults: "Ваши результаты:",
    product: "Продукт",
    yourAnswer: "Ваш ответ",
    correctAnswer: "Правильный ответ",
    goodJob: "Ты большой молодец!",
    goodButKeepLearning: "Результат хороший, но не забудь поговорить с ФКУ специалистами!",
    contactYourDoctor: "Могло бы быть и лучше! Запишись на консультацию к ФКУ специалистам!",
    correctAnswers: "Правильные ответы",
    from: "от",
    yes: "ДА", 
    continue: "ПРОДОЛЖАТЬ",
    areYouSure: "Вы уверены, что хотите выйти из игры??",
    playAgain: "Cыграй еще раз",
    stillLeft: "Oсталось", 
    questions: "вопросов",
    saveResults: "Cохранить результаты",
    save: "СОХРАНЯТЬ",
    enterPatientsName: "Введите свое имя и фамилию, чтобы сохранить результаты в формате PDF (на английском языке)",
    inputPlaceholder: "Пожалуйста, введите имя и фамилию пациента",
    validationText: "Необходимо ввести слово длиной не менее 5 символов",
}

export const translationsEN: Translation= {
    green: "Allowed",
    red: "Forbidden",
    yellow: "Partially allowed",
}